export default __webpack_public_path__ + "static/media/car.0011cfe8.svg";